import { Component, Input } from '@angular/core';

@Component({
  selector: 'icon-preparing-campaign',
  templateUrl: './icon-preparing-campaign.component.html',
  styleUrls: ['./icon-preparing-campaign.component.scss']
})
export class IconPreparingCampaignComponent {}
